import { CostTableRow } from "../types/CostTableRow";

export const serviceSuggestions: CostTableRow[] = [
  {
    id: "onboarding_basic",
    name: "Onboarding - Basic",
    listPrice: 0,
    discount: 0,
    amount: 1,
  },
  {
    id: "onboarding_advanced",
    name: "Onboarding - Advanced",
    listPrice: 995,
    discount: 0,
    amount: 1,
  },
  {
    id: "onboarding_premium",
    name: "Onboarding - Premium",
    listPrice: 2995,
    discount: 0,
    amount: 1,
  },
  {
    id: "workflow_automation_advanced",
    name: "Workflow Automation - Advanced",
    listPrice: 995,
    discount: 0,
    amount: 1,
  },
  {
    id: "workflow_automation_premium",
    name: "Workflow Automation - Premium",
    listPrice: 2395,
    discount: 0,
    amount: 1,
  },
  {
    id: "workflow_automation_premium_plus",
    name: "Workflow Automation - Premium+",
    listPrice: 5850,
    discount: 0,
    amount: 1,
  },
  {
    id: "professional_service",
    name: "Professional Service - Hourly",
    listPrice: 195,
    discount: 0,
    amount: 1,
  },
];
